import { getRecommendedLeaguesUseCase } from '@/domain/use-cases/get-recommended-leagues.use-case';
import { Result } from '@/entities';
import { League } from '@/entities';

export const getRecommendedLeaguesController = async (): Promise<Result<League[]>> => {
	return getRecommendedLeaguesUseCase();
};
